/**
 * TipoOcorrencia
 * @author Simpli CLI generator
 */
import {
    $,
    HttpBody,
    ID,
    Resource,
    ResponseSerialize,
    TAG,
    ValidationMaxLength,
    ValidationRequired,
} from 'simpli-web-sdk'
import TipoOcorrenciaSucessoSchema from '@/schema/TipoOcorrenciaSucesso.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class TipoOcorrenciaSucesso extends Resource {
    get $schema() {
        return TipoOcorrenciaSucessoSchema(this)
    }

    get $id() {
        return this.idTipoOcorrenciaSucessoPk
    }

    set $id(val: ID) {
        this.idTipoOcorrenciaSucessoPk = val
    }

    get $tag() {
        return this.nome
    }

    set $tag(val: TAG) {
        this.nome = val
    }

    static async persistLoteTipoOcorrencia(listToPersist: TipoOcorrenciaSucesso[],
                                           spinner = 'persistLoteTipoOcorrencia') {
        const fetch = async () => {
            return await new HttpBody(Number).POST(`/user/lote-tipo-ocorrencia-sucesso`, listToPersist)
        }

        return await $.await.run(fetch, spinner)
    }

    readonly $name: string = 'TipoOcorrenciaSucesso'

    readonly $endpoint: string = '/user/tipo-ocorrencia-sucesso{/id}'

    @ResponseSerialize(Responsavel)
    responsavel: Responsavel | null = null

    idTipoOcorrenciaSucessoPk: ID = 0

    idOcorrenciaExterna: number | null = null

    @ValidationRequired()
    @ValidationMaxLength(100)
    nome: string = ''

    @ValidationRequired()
    ativo: boolean = false

    async persistTipoOcorrencia(spinner = 'persistTipoOcorrencia') {
        const fetch = async () => {
            await this.validate()
            return await this.POST(`/user/tipo-ocorrencia-sucesso`, this)
        }

        return await $.await.run(fetch, spinner)
    }

    async getTipoOcorrencia(id: ID, spinner = 'getTipoOcorrencia') {
        const fetch = async () => await this.GET(`/user/tipo-ocorrencia-sucesso/${id}`)
        return await $.await.run(fetch, spinner)
    }

    async removeTipoOcorrencia(id: number, spinner = 'removeTipoOcorrencia') {
        const fetch = async () => await this.DELETE(`/user/tipo-ocorrencia-sucesso/${id}`)
        return await $.await.run(fetch, spinner)
    }
}
